{
  "login-page": {
    "buttons": {
      "next": "Suivant",
      "sign-up": "Créer un nouveau compte",
      "update-password": "Mise à jour du mot de passe",
      "use-phone-to-login": "Connexion avec le numéro de téléphone",
      "use-email-to-login": "Se connecter avec l'email"
    },
    "text": {
      "title": "Connexion",
      "subtitle": "Se connecter à Beauty Booking",
      "email": "Votre email",
      "or": "OU",
      "password": "Mot de passe",
      "password-hint": "Vous devez mettre à jour votre mot de passe",
      "username": "Nom d'utilisateur",
      "username-hint": "Vous devez saisir votre adresse électronique ou votre numéro de téléphone"
    }
  }
}
